module.exports = __webpack_public_path__ + "img/Jan met zaag.6f194714.jpg";